import React, { useEffect, useState } from "react";
import { DateUtility } from "../../utils/dateUtility";
import { convertDateTime } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";
// import "./Table.scss";
// import "./CricketInfoTable.scss";

const CricketInfoTable = ({
  ServerData,
  difference,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketmatch");
    }
  }, [loadCSS]);
  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <div>
        <div className="leg_head">
          <h2> {dictionary?.matchinfo || "Match Info"}</h2>
        </div>
        <div className="global_table cr_macth_info">
          <table>
            <tbody>
              <tr>
                <td>{dictionary?.event || "Event"}</td>
                <td>{data?.evt}</td>
              </tr>
              <tr>
                <td> {dictionary?.thismatch || "This Match"}</td>
                <td>{data?.type || "-"}</td>
              </tr>
              <tr>
                <td> {dictionary?.starts || "Starts"} (venue)</td>
                <td>
                  {convertDateTime(data?.ldt)},
                  {DateUtility.ConvertCETtoCurrentTimeZone(
                    data?.ldt,
                    difference
                  )}
                </td>
              </tr>
              <tr>
                <td>{dictionary?.starts || "Starts"} (GMT)</td>
                <td>
                  {convertDateTime(data?.gdt)},
                  {DateUtility.ConvertCETtoCurrentTimeZone(
                    data?.gdt,
                    difference
                  )}
                </td>
              </tr>
              {data?.ts_win && (
                <tr>
                  <td>{dictionary?.toss || "Toss"}</td>
                  <td>
                    {data?.ts_win}{" "}
                    {dictionary?.wonthetossandchoseto ||
                      "won the toss and chose to"}{" "}
                    {data?.elc}
                  </td>
                </tr>
              )}
              <tr>
                <td> {dictionary?.country || "Country"}</td>
                <td>{data?.stad?.ctry}</td>
              </tr>
              <tr>
                <td> {dictionary?.city || "City"}</td>
                <td>{data?.stad?.cty}</td>
              </tr>
              <tr>
                <td> {dictionary?.venue || "Venue"}</td>
                <td>{data?.stad?.nm}</td>
              </tr>
              <tr>
                <td> {dictionary?.umpire || "Umpire"}</td>
                <td>
                  {data?.match_umpires?.find((umpire) => umpire.pos === "first")
                    ?.umpire?.nm || "-"}{" "}
                  &nbsp;
                  {data?.match_umpires?.find(
                    (umpire) => umpire.pos === "second"
                  )?.umpire?.nm || "-"}
                </td>
              </tr>
              <tr>
                <td> {dictionary?.tvumpire || "TV Umpire"}</td>
                <td>
                  {data?.match_umpires?.find(
                    (umpire) => umpire.pos === "tv_umpire"
                  )?.umpire?.nm || "-"}
                </td>
              </tr>
              <tr>
                <td> {dictionary?.referee || "Referee"} </td>
                <td>
                  {data?.match_umpires?.find(
                    (umpire) => umpire.pos === "referee"
                  )?.umpire?.nm || "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CricketInfoTable;
